/* eslint-disable react-hooks/exhaustive-deps */
import {
  Document,
  Packer,
  Paragraph,
  TextRun,
  Table,
  TableRow,
  TableCell,
  AlignmentType,
  WidthType,
} from 'docx';
import { saveAs } from 'file-saver';

import { jsPDF } from 'jspdf';

export type PayslipData = {
  employeeName: string;
  email: string;
  designation: string;
  dateOfJoining: string;
  salaryDate: string;
  payPeriod: string;
  workedDays: number;
  leaveDays: number;
  basicPay: string;
  currency: string;
  incentivePay: string;
  houseRentAllowance: string;
  providentFund: string;
  professionalTax: string;
  loanDeduction: string;
  grossPay: string;
  netPay: string;
  paymentMethod: string;
  bankAccountNumber: string;
  bankName: string;
};

export interface PDFSlipProps {
  payslipData: PayslipData;
  isDoc: boolean;
}

function AISlip({ payslipData, isDoc = false }: PDFSlipProps) {
  const generatePDF = () => {
    const doc = new jsPDF();
    const fontSize = 12;
    doc.setFontSize(fontSize);

    const boxX = 20;
    const boxY = 24;
    const boxWidth = 180 + 100 + 20;
    const boxHeight = 32;

    doc.setFillColor(220, 216, 233);
    doc.rect(boxX - 5, boxY - 5, boxWidth, boxHeight, 'F');
    const leftColumnX = boxX;
    const leftColumnWidth = 90;
    const employeeDetailsY = boxY + 3;
    doc.setFontSize(14);
    doc.text(`${payslipData.employeeName}`, leftColumnX + 5, employeeDetailsY);

    doc.setFontSize(10);
    doc.setFont('helvetica', 'bold');
    const maxWidth = 80;
    const addressLines = doc.splitTextToSize(
      payslipData.designation || 'Unasssigned ',
      maxWidth
    );
    addressLines.forEach((line, index) => {
      doc.text(line, leftColumnX + 5, employeeDetailsY + 6);
    });
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');

    const phoneNumber = '';
    const email = payslipData.email;

    doc.text(` ${phoneNumber}`, leftColumnX + 4, employeeDetailsY + 12);
    doc.text(`${email}`, leftColumnX + 5, employeeDetailsY + 18);

    const rightColumnX = leftColumnX + leftColumnWidth + 10;
    const titleTextY = employeeDetailsY + 14;

    doc.setFontSize(50);
    doc.setTextColor(129, 115, 179);
    doc.text('PAY SLIP', rightColumnX + 5, titleTextY);
    doc.setFontSize(10);
    doc.setTextColor(0, 0, 0);

    doc.setFont('helvetica', 'bold');
    doc.text('Date of Joining', 15, 65);
    doc.setFont('helvetica', 'normal');
    doc.text(`: ${payslipData.dateOfJoining}`, 50, 65);

    doc.setFont('helvetica', 'bold');
    doc.text('Salary Date', 100, 65);
    doc.setFont('helvetica', 'normal');
    doc.text(`: ${payslipData.salaryDate}`, 130, 65);

    doc.setFont('helvetica', 'bold');
    doc.text('Type', 15, 70);
    doc.setFont('helvetica', 'normal');
    doc.text(`: ${payslipData.paymentMethod}`, 50, 70);

    doc.setFont('helvetica', 'bold');
    doc.text('Worked Days', 100, 70);
    doc.setFont('helvetica', 'normal');
    doc.text(`: ${payslipData.workedDays.toString()}`, 130, 70);

    doc.setFont('helvetica', 'bold');
    doc.text('Pay Period', 15, 75);
    doc.setFont('helvetica', 'normal');
    doc.text(`: ${payslipData.payPeriod}`, 50, 75);

    doc.setFont('helvetica', 'bold');
    doc.text('Identification No.', 100, 75);
    doc.setFont('helvetica', 'normal');
    doc.text(`: ${payslipData.bankAccountNumber}`, 130, 75);

    doc.setTextColor(129, 115, 179);
    doc.setFont('helvetica', 'bold');
    doc.text('Earnings', 15, 90);
    doc.text('Amount', 170, 97);
    doc.setDrawColor(129, 115, 179);
    doc.line(15, 92, 190, 92);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(0, 0, 0);
    doc.text(`Basic Pay`, 15, 104);
    doc.text(`${payslipData.basicPay}`, 172, 104);
    doc.text(`House Rent Allowance`, 15, 110);
    doc.text(`${payslipData.houseRentAllowance}`, 172, 110);
    doc.text(`Other Allowances`, 15, 116);
    doc.text(`${payslipData.incentivePay}`, 172, 116);
    doc.text(`Reimbursement`, 15, 122);
    doc.text(`${payslipData.incentivePay}`, 172, 122);

    const totalEarnings = (
      Number(payslipData.basicPay || 0) +
      Number(payslipData.houseRentAllowance || 0) +
      Number(payslipData.incentivePay || 0)
    ).toFixed(2);

    doc.text(`Total Earnings`, 140, 132);
    doc.text(`${totalEarnings}`, 172, 132);

    doc.setTextColor(129, 115, 179);
    doc.setFont('helvetica', 'bold');
    doc.text('Deductions', 15, 140);
    doc.text('Amount', 170, 140);
    doc.line(15, 142, 190, 142);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(0, 0, 0);
    doc.text(`Provident Fund `, 15, 148);
    doc.text(`${payslipData.providentFund}`, 172, 148);
    doc.text(`Professional Tax`, 15, 154);
    doc.text(`${payslipData.professionalTax}`, 172, 154);
    doc.text(`Loan Deduction`, 15, 160);
    doc.text(`${payslipData.loanDeduction}`, 172, 160);

    const totalDeductions = (
      Number(payslipData.providentFund || 0) +
      Number(payslipData.professionalTax || 0) +
      Number(payslipData.loanDeduction || 0)
    ).toFixed(2);

    doc.line(15, 174, 190, 174);
    doc.text(`Total Deductions`, 140, 168);
    doc.text(`${totalDeductions}`, 172, 168);

    const netPay = (
      parseFloat(totalEarnings) - parseFloat(totalDeductions)
    ).toFixed(2);

    doc.setTextColor(129, 115, 174);
    doc.setFont('helvetica', 'bold');
    doc.text('Additional Information', 15, 180);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(0, 0, 0);
    doc.text(`Bank Account Number: ${payslipData.bankAccountNumber}`, 15, 186);
    const salaryBoxX = 140;
    const salaryBoxWidth = 120;
    const salaryBoxHeight = 25;

    doc.setFont('helvetica', 'bold');
    doc.text(`Gross Income:`, 145, 180);
    doc.setFont('helvetica', 'normal');
    doc.text(`${payslipData.grossPay}`, 172, 180);

    doc.setFillColor(220, 216, 240);
    doc.rect(salaryBoxX, 190, salaryBoxWidth, salaryBoxHeight, 'F');
    doc.setTextColor(0, 0, 0);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(14);
    doc.text(`${netPay}`, salaryBoxX + 41, 205);
    doc.setFontSize(12);
    doc.setFont('helvetica', 'normal');
    doc.text(`Total Pay:`, salaryBoxX + 6, 205);
    doc.setTextColor(0, 0, 0);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(13);
    doc.text(payslipData.currency, salaryBoxX + 30, 205);

    const footerY = 230;
    const footerText = 'This is a system-generated payslip';
    doc.setFontSize(8);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(0, 0, 0);
    doc.text(footerText, 80, footerY);

    const [month, year] = payslipData.payPeriod.split(' ');
    const employeeName = payslipData.employeeName
      ? payslipData.employeeName.replace(/\s+/g, '_')
      : 'Unnamed_Employee';
    const filename = `${employeeName}_${month.toLowerCase()}_${year}.pdf`;
    doc.save(filename);
  };

  const generateDocx = async () => {
    const earnings = [
      { label: 'Basic Pay', value: payslipData.basicPay },
      { label: 'House Rent Allowance', value: payslipData.houseRentAllowance },
      { label: 'Other Allowances', value: payslipData.incentivePay },
      { label: 'Reimbursement', value: payslipData.incentivePay },
    ];

    const deductions = [
      { label: 'Provident Fund', value: payslipData.providentFund },
      { label: 'Professional Tax', value: payslipData.professionalTax },
      { label: 'Loan Deduction', value: payslipData.loanDeduction },
    ];

    const totalEarnings = (
      Number(payslipData.basicPay || 0) +
      Number(payslipData.houseRentAllowance || 0) +
      Number(payslipData.incentivePay || 0)
    ).toFixed(2);

    const totalDeductions = (
      Number(payslipData.providentFund || 0) +
      Number(payslipData.professionalTax || 0) +
      Number(payslipData.loanDeduction || 0)
    ).toFixed(2);

    const netPay = (
      parseFloat(totalEarnings) - parseFloat(totalDeductions)
    ).toFixed(2);

    const employeePageLayoutTable = new Table({
      rows: [
        new TableRow({
          children: [
            new TableCell({
              children: [
                new Paragraph({
                  children: [
                    new TextRun({
                      text: payslipData.employeeName,
                      bold: true,
                      size: 28,
                    }),
                  ],
                }),
                new Paragraph(payslipData.designation),
                new Paragraph(`Email: ${payslipData.email}`),
              ],
              shading: { fill: 'DDD8E9' },
            }),
            new TableCell({
              children: [
                new Paragraph({
                  children: [
                    new TextRun({
                      text: 'PAY SLIP',
                      bold: true,
                      size: 72,
                      color: '8173B3',
                    }),
                  ],
                }),
              ],
              verticalAlign: 'center',
              shading: { fill: 'DDD8E9' },
            }),
          ],
        }),
      ],
      width: { size: 100, type: WidthType.PERCENTAGE },
    });

    const detailsTable = new Table({
      rows: [
        new TableRow({
          children: [
            new TableCell({ children: [new Paragraph('Date of Joining')] }),
            new TableCell({
              children: [new Paragraph(payslipData.dateOfJoining)],
            }),
            new TableCell({ children: [new Paragraph('Salary Date')] }),
            new TableCell({
              children: [new Paragraph(payslipData.salaryDate)],
            }),
          ],
        }),
        new TableRow({
          children: [
            new TableCell({ children: [new Paragraph('Payment Method')] }),
            new TableCell({
              children: [new Paragraph(payslipData.paymentMethod)],
            }),
            new TableCell({ children: [new Paragraph('Pay Period')] }),
            new TableCell({
              children: [new Paragraph(payslipData.payPeriod)],
            }),
          ],
        }),
        new TableRow({
          children: [
            new TableCell({ children: [new Paragraph('Identification No.')] }),
            new TableCell({
              children: [new Paragraph(payslipData.bankAccountNumber)],
            }),
          ],
        }),
      ],
      width: { size: 100, type: WidthType.PERCENTAGE },
    });

    const sectionPageLayout = (text: string) =>
      new Paragraph({
        children: [
          new TextRun({ text, bold: true, color: '8173B3', size: 28 }),
        ],
      });

    const earningsTable = new Table({
      rows: [
        new TableRow({
          children: [
            new TableCell({
              children: [
                new Paragraph({
                  children: [new TextRun({ text: 'Earnings', bold: true })],
                }),
              ],
            }),
            new TableCell({
              children: [
                new Paragraph({
                  children: [new TextRun({ text: 'Amount', bold: true })],
                }),
              ],
            }),
          ],
        }),
        ...earnings.map(
          (e) =>
            new TableRow({
              children: [
                new TableCell({ children: [new Paragraph(e.label)] }),
                new TableCell({
                  children: [new Paragraph(e.value.toString())],
                }),
              ],
            })
        ),
        new TableRow({
          children: [
            new TableCell({
              children: [
                new Paragraph({
                  children: [
                    new TextRun({ text: 'Total Earnings', bold: true }),
                  ],
                }),
              ],
            }),
            new TableCell({ children: [new Paragraph(totalEarnings)] }),
          ],
        }),
      ],
      width: { size: 100, type: WidthType.PERCENTAGE },
    });

    const deductionsTable = new Table({
      rows: [
        new TableRow({
          children: [
            new TableCell({
              children: [
                new Paragraph({
                  children: [new TextRun({ text: 'Deductions', bold: true })],
                }),
              ],
            }),
            new TableCell({
              children: [
                new Paragraph({
                  children: [new TextRun({ text: 'Amount', bold: true })],
                }),
              ],
            }),
          ],
        }),
        ...deductions.map(
          (d) =>
            new TableRow({
              children: [
                new TableCell({ children: [new Paragraph(d.label)] }),
                new TableCell({
                  children: [new Paragraph(d.value.toString())],
                }),
              ],
            })
        ),
        new TableRow({
          children: [
            new TableCell({
              children: [
                new Paragraph({
                  children: [
                    new TextRun({ text: 'Total Deductions', bold: true }),
                  ],
                }),
              ],
            }),
            new TableCell({ children: [new Paragraph(totalDeductions)] }),
          ],
        }),
      ],
      width: { size: 100, type: WidthType.PERCENTAGE },
    });

    const totalPayBox = new Table({
      rows: [
        new TableRow({
          children: [
            new TableCell({
              children: [
                new Paragraph({
                  children: [
                    new TextRun({
                      text: `Total Pay: ${netPay} ${payslipData.currency}`,
                      bold: true,
                    }),
                  ],
                }),
              ],
              shading: { fill: 'DDD8F0' },
            }),
          ],
        }),
      ],
      width: { size: 50, type: WidthType.PERCENTAGE },
    });

    const doc = new Document({
      sections: [
        {
          children: [
            employeePageLayoutTable,
            new Paragraph(' '),
            detailsTable,
            new Paragraph(' '),
            sectionPageLayout('Earnings'),
            earningsTable,
            new Paragraph(' '),
            sectionPageLayout('Deductions'),
            deductionsTable,
            new Paragraph(' '),
            new Paragraph(`Gross Income: ${payslipData.grossPay}`),
            totalPayBox,
            new Paragraph(
              `Bank Account Number: ${payslipData.bankAccountNumber}`
            ),
            new Paragraph(' '),
            new Paragraph({
              children: [
                new TextRun({
                  text: 'This is a system-generated payslip',
                  size: 16,
                  bold: true,
                }),
              ],
              alignment: AlignmentType.CENTER,
            }),
          ],
        },
      ],
    });

    const blob = await Packer.toBlob(doc);
    const [month, year] = payslipData.payPeriod.split(' ');
    const employeeName = payslipData.employeeName
      ? payslipData.employeeName.replace(/\s+/g, '_')
      : 'Unnamed_Employee';

    const filename = `${employeeName}_${month.toLowerCase()}_${year}.docx`;
    saveAs(blob, filename);
  };

  return (
    <div>
      <button
        onClick={isDoc ? generateDocx : generatePDF}
        style={{
          backgroundColor: '#8254ff',
          color: 'white',
          padding: '10px 16px',
          fontSize: '14px',
          border: 'none',
          borderRadius: '6px',
          cursor: 'pointer',
        }}
      >
        Download Payslip
      </button>
    </div>
  );
}

export default AISlip;
